/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Priority_SpeakerInputs */



/**
* | output |
* | --- |
* | "Priority Speaker" |
*
* @param {Leveling_Perm_Priority_SpeakerInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_priority_speaker = /** @type {((inputs?: Leveling_Perm_Priority_SpeakerInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Priority_SpeakerInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Приоритетный режим")
	return /** @type {LocalizedString} */ ("Priority Speaker")
});